const Return = ({
  width = "20px",
  height = "22px",
  currentColor = "currentColor",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.525 16.2642L15.562 17.3972V9.22125L18.225 7.76125V15.0513C18.225 15.5513 17.959 16.0142 17.525 16.2642ZM10.503 20.3182V11.9942L13.861 10.1532V18.3792L10.503 20.3182ZM2.01 5.78125L5.178 3.95225L13.29 8.52725L9.848 10.4132C9.73 10.3012 9.603 10.1962 9.458 10.1122L2.01 5.78125ZM9.107 1.68425C9.541 1.43325 10.075 1.43325 10.507 1.68425L17.525 5.73525C17.656 5.81025 17.765 5.91025 17.863 6.01925L15.046 7.56425L6.889 2.96425L9.107 1.68425ZM18.564 4.73025L10.858 0.28125C10.209 -0.09375 9.407 -0.09375 8.756 0.28125L1.05 4.73025C0.4 5.10525 0 5.80025 0 6.55025V15.4493C0 16.2003 0.4 16.8933 1.05 17.2693L8.756 21.7183C9.407 22.0933 10.209 22.0933 10.858 21.7183L18.564 17.2693C19.214 16.8933 19.615 16.2003 19.615 15.4493V6.55025C19.615 5.80025 19.214 5.10525 18.564 4.73025Z"
      fill={currentColor}
    />
  </svg>
);

export default Return;
